import React, { useState, useEffect } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import chunk from 'lodash/chunk';

import { fetchTopSellersSection } from 'Redux/ducks/algolia-calls';
import CardPanelCarousel from 'Components/Carousel/CardPanelCarousel/CardPanelCarousel';
import ErrorBoundary from 'Components/Utility/ErrorBoundary';
import useViewport from 'Hooks/useViewport';

const messages = defineMessages({
  title: {
    id: 'featured-top-seller-carousel.title',
    defaultMessage: 'Top Deals',
  },
});

const FeaturedTopSellerCarousel = () => {
  const [slides, setSlides] = useState([]);

  const { isAboveLg } = useViewport();

  const intl = useIntl();
  const { formatMessage } = intl;

  let chunkNumber = 3;
  if (isAboveLg) chunkNumber = 5;

  useEffect(() => {
    const fetchTopSellers = async () => {
      const newHits = await fetchTopSellersSection(15);

      const formattedSlides = [];
      if (!isEmpty(newHits)) {
        newHits.forEach((hit) => {
          formattedSlides.push({
            _id: hit.product_id,
            img: hit.cover,
            hit,
            name: hit.name,
            type: hit.type === 'bundle' || hit.type === 'pick-and-mix' ? 'bundle' : 'product',
            url: `https://www.fanatical.com/en/${hit.type}/${hit.slug}`,
            categories: hit.categories,
            external_link: false,
            sort_order: null,
          });
        });
      }
      const carouselChunks = chunk(formattedSlides, chunkNumber);
      setSlides(carouselChunks);
    };

    fetchTopSellers();
  }, [chunkNumber]);

  return (
    <ErrorBoundary hideForm>
      <CardPanelCarousel
        FeaturedTopSellerCarousel
        slides={slides}
        title={formatMessage(messages.title)}
      />
    </ErrorBoundary>
  );
};

export default FeaturedTopSellerCarousel;
